import React from 'react'
import { createUseStyles } from 'react-jss'
import breakpoints from '../../theme/breakpoints'
import { colors } from '../../theme/palette'

const useStyles = createUseStyles((theme) => ({
    container: {
        position: 'relative',
        marginTop: '3.75rem',
        color: theme.palette.secondary,
        minHeight: '100dvh',
        width: '100%',
        backgroundColor: colors.gray500,
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            marginTop: `calc(${theme.sizes.navbarDesktopHeight} + 7rem)`,
        },
    },
}))

const Layout: React.FC = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.container}>{children}</div>
}

export default Layout
